
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@sunSource/Services/ContactUsFormServices";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess &
    HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    const state = props.getState().components.contactUsForm;
 

    props.apiParameter = {
        'Customer #': state.fieldValues['customerNumber'],
        'First Name': state.fieldValues["firstName"],
        "Last Name": state.fieldValues["lastName"],
        "Company": state.fieldValues["companyName"],
        "Email Address": state.fieldValues["emailAddress"],
        "Phone Number": state.fieldValues["phoneNumber"],
        "State":state.fieldValues['topic'],
        "Zip Code":state.fieldValues['zipcodeName'],
        "Supplier":state.fieldValues['supplierName'],
        "Model or Series":state.fieldValues['modelName'],
        "Additional Details on Your Inquiry":state.fieldValues['message'],
        "Url":state.fieldValues['currentUrl'],
        "vendor":state.fieldValues['vendor'],
    };
};

const CustomSendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await submitContactUsForm(props.apiParameter);
        props.apiResult = {
            success: true,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (!props.apiResult.success) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
